import { render } from "./ContactThanksPage.vue?vue&type=template&id=76b67edd&scoped=true"
import script from "./ContactThanksPage.vue?vue&type=script&lang=js"
export * from "./ContactThanksPage.vue?vue&type=script&lang=js"

import "./ContactThanksPage.vue?vue&type=style&index=0&id=76b67edd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b67edd"]])

export default __exports__